import { jsx as a } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import g from "classnames";
import { TagVariant as e } from "./types.js";
/* empty css         */
import { memo as o } from "../../../external/preact/compat/dist/compat.module.js";
const s = o(({ variant: p = e.DEFAULT, label: t }) => /* @__PURE__ */ a(
  "div",
  {
    className: g("adyen-pe-tag", {
      // [TODO]: These Bento tag variants definitions are outdated
      "adyen-pe-tag--success": p === e.SUCCESS,
      "adyen-pe-tag--default": p === e.DEFAULT,
      "adyen-pe-tag--warning": p === e.WARNING,
      "adyen-pe-tag--error": p === e.ERROR,
      "adyen-pe-tag--primary": p === e.WHITE,
      "adyen-pe-tag--light": p === e.LIGHT,
      "adyen-pe-tag--light-with-outline": p === e.LIGHT_WITH_OUTLINE,
      // Adopted from the latest Bento tag variants spec
      "adyen-pe-tag--blue": p === e.BLUE
    }),
    children: t
  }
));
export {
  s as Tag
};
